import { normalizeText } from "@/common/utils/formatters";
import { OPTIONAL_QUANTITY_LABELS } from "../constants/optionalQuantityLabels.constant";

export class MissionRequirementsTransformer {
  static isValueRequiredForType(label?: string) {
    const normalized = normalizeText(label);
    if (!normalized) return true;
    return !OPTIONAL_QUANTITY_LABELS.some((text) => normalized.includes(text));
  }

  static fallbackValueForType(label?: string) {
    return MissionRequirementsTransformer.isValueRequiredForType(label)
      ? ""
      : "1";
  }

  static sanitizePositiveNumericValue(value: string) {
    const cleaned = value.replace(/[^0-9.,-]/g, "");
    if (!cleaned.trim()) return "";
    const parsed = parseFloat(cleaned.replace(",", "."));
    if (!Number.isFinite(parsed) || parsed <= 0) return "";
    return cleaned;
  }
}
